import React from 'react';
import PropTypes from 'prop-types';
import { Header, Grid } from 'semantic-ui-react';

import WorkshopImageUpload from '../WorkshopImageUpload';

const WorkshopHeader = ({ SKUId, title, subTitle, coverImageUrl, cardImageUrl, SKUCode }) => {
  return (
    <Grid>
      <Grid.Row>
        <Grid.Column width={8}>
          <WorkshopImageUpload
            changeImgText="Change cover image"
            skuCode={SKUCode}
            fileImageUrl={coverImageUrl && coverImageUrl !== '' ? coverImageUrl : undefined}
            accessor={'coverImage'}
          />
        </Grid.Column>
        <Grid.Column width={4}>
          <WorkshopImageUpload
            changeImgText="Change card image"
            skuCode={SKUCode}
            fileImageUrl={cardImageUrl && cardImageUrl !== '' ? cardImageUrl : undefined}
            accessor={'cardImage'}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Column width={16}>
        <Grid.Row>
          <Header size="huge">{title}</Header>
        </Grid.Row>
        <Grid.Row>
          <Header size="large">{subTitle}</Header>
        </Grid.Row>
      </Grid.Column>
    </Grid>
  );
};

WorkshopHeader.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  theme: PropTypes.string,
  coverImageUrl: PropTypes.string,
  cardImageUrl: PropTypes.string,
  SKUCode: PropTypes.string,
};

export default WorkshopHeader;
